export default __webpack_public_path__ + "static/media/a037-6.94ad46a7.svg";